import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Компонент с ссылками на правила использования и информацию о компании
 * Используется на страницах Payment и Home
 */
const TermsAndInfo = () => {
  const { t } = useTranslation()

  return (
    <div className="p-6 pt-4 text-center space-y-3">
      <a
        href="https://t.me/skinoz_support_bot"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center rounded-full bg-accent-primary/20 border border-accent-primary/40 px-4 py-2 text-sm text-accent-primary hover:bg-accent-primary/30 hover:text-white transition-colors"
      >
        {t('profile.support')}
      </a>

      <div className="flex flex-wrap items-center justify-center gap-4">
        <a
          href="https://telegra.ph/SKINOZ-Terms-of-Service-09-23"
          target="_blank"
          rel="noopener noreferrer"
          className="text-text-secondary text-xs hover:text-white transition-colors underline"
        >
          Terms of Service
        </a>

        <a
          href="https://telegra.ph/SKINOZ-Privacy-Policy-12-02"
          target="_blank"
          rel="noopener noreferrer"
          className="text-text-secondary text-xs hover:text-white transition-colors underline"
        >
          Privacy Policy
        </a>
      </div>

      {/* Информация о компании */}
      <div className="text-text-secondary text-[9px] leading-relaxed opacity-60">
        <p className="font-semibold">AI GAMING SOLUTIONS LTD. LLC-4829-23</p>
        <p>BELIZE CITY, 45 BARRACK ROAD,</p>
        <p>SECOND FLOOR, SUITE 207, BELIZE</p>
      </div>
    </div>
  )
}

export default TermsAndInfo
